import { useSearchParams } from 'next/navigation';

import AuthModal from '@/components/authForm/AuthModal';
import { getPodcastRedirectUrl } from '@/components/campaign';
import { useAuthPrompt } from '@/context/auth/AuthPromptProvider';
import { useApi } from '@/hooks/api';
import { usePricesState, useUserState } from '@/hooks/store';
import { useRouterPush } from '@/hooks/utils/useRouterPush';
import { User } from '@/store/user/types';
import isValidLifetimeCoupon from '@/utils/prices/isValidLifetimeCoupon';
import { userCanTrial } from '@/utils/subscriptions';

import { shouldCheckTermsStatus, shouldShowToS } from './utils';

const HeaderAuthModal = () => {
	const routerPush = useRouterPush();
	const { authPrompt } = useAuthPrompt();
	const user = useUserState();
	const prices = usePricesState();
	const searchParams = useSearchParams();
	const apiRequest = useApi();

	const onAuthSuccess = async (_user: User): Promise<void> => {
		if (searchParams?.get('utm_medium') === 'podcast') {
			const hasLifeTimeUpsellCoupon = isValidLifetimeCoupon(prices);
			const podcastRedirectUrl = getPodcastRedirectUrl(user, prices, hasLifeTimeUpsellCoupon);

			routerPush(podcastRedirectUrl);
		} else if (authPrompt === 'signup' && userCanTrial(_user)) {
			routerPush('/signup-flow');
		} else if (shouldCheckTermsStatus(_user)) {
			const showToS = await shouldShowToS(_user, apiRequest);
			routerPush(showToS ? '/b2b/tos' : '/app');
		} else {
			routerPush('/app');
		}
	};

	return <AuthModal onAuthSuccess={onAuthSuccess} />;
};

export default HeaderAuthModal;
